module.exports = [
	'Standard PAYE',
	'Self Employed',
	'Unknown',
]


//////////////////
// WEBPACK FOOTER
// ../server/constants/employmentSchemes.js
// module id = 1190
// module chunks = 0